export default {
    mobileConstants: {
        deviceTypes: {
            desktop: "Desktop",
            mobile: "Mobile",
            tablet: "Tablet",
            deviceDefault: "Desktop",
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/mobile-constants.ts